"use client";

import { useEffect } from "react";
import { axiosPrivate, axiosPublic } from "../axios/axiosConfig";
import useAuth from "../hooks/useAuth";

const useAxiosPrivate = () => {
  const { auth, setAuth } = useAuth();
  useEffect(() => {
    const requestIntercept = axiosPrivate.interceptors.request.use(
      (config) => {
        console.log("request distributor");
        if (!config.headers["Authorization"]) {
          config.headers["Authorization"] = `Bearer ${auth?.accessToken}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    const responseIntercept = axiosPrivate.interceptors.response.use(
      (response) => response,
      async (error) => {
        const prevRequest = error?.config;

        if (error?.response?.status === 403 && !prevRequest?.sent) {
          prevRequest.sent = true;

          try {
            // Call refresh without interceptors to avoid nested retries
            console.log("Attempting to refresh token...distributor");
            const refresh = await axiosPublic.get(
              "/distributor-user/refresh-token"
            );
            setAuth((prev) => ({
              ...prev,
              accessToken: refresh.data?.accessToken,
              distributorId: refresh.data?.distributorId,
            }));
            prevRequest.headers[
              "Authorization"
            ] = `Bearer ${refresh.data?.accessToken}`;
            return axiosPrivate(prevRequest);
          } catch (refreshError) {
            console.error("Token refresh failed:", refreshError);
            setAuth((prev) => ({ ...prev, accessToken: "" }));
            await axiosPublic.get("/distributor-user/logout");
            window.location.href = "/login";
            return Promise.reject(refreshError);
          }
        }

        return Promise.reject(error);
      }
    );

    return () => {
      axiosPrivate.interceptors.request.eject(requestIntercept);
      axiosPrivate.interceptors.response.eject(responseIntercept);
    };
  }, []);

  return axiosPrivate;
};

export default useAxiosPrivate;
